import request from '@/utils/request'

export function getOrderContactList(data) {
  return request({ url: '/admin/order-contact/list', method: 'post', data })
}

export function getOrderContactServiceOrders(data) {
  return request({ url: '/admin/order-contact/service-orders', method: 'post', data })
}
